module.exports = __webpack_public_path__ + "img/网站3-54.22ace0b3.png";